// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#162b64","menuActiveText":"#435ebe","theme":"#06c"};